/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * * `ABAI` - ABAI (American Board of Allergy and Immunology)
 * * `ABA` - ABA (American Board of Anesthesiology)
 * * `ABD` - ABD (American Board of Dermatology)
 * * `ABEM` - ABEM (American Board of Emergency Medicine)
 * * `ABFM` - ABFM (American Board of Family Medicine)
 * * `ABIM` - ABIM (American Board of Internal Medicine)
 * * `ABMGG` - ABMGG (American Board of Medical Genetics and Genomics)
 * * `ABNS` - ABNS (American Board of Neurological Surgery)
 * * `ABOG` - ABOG (American Board of Obstetrics and Gynecology)
 * * `ABO` - ABO (American Board of Ophthalmology)
 * * `ABOS` - ABOS (American Board of Orthopedic Surgery)
 * * `ABOHNS` - ABOHNS (American Board of Otolaryngology - Head and Neck Surgery)
 * * `ABPATH` - ABPath (American Board of Pathology)
 * * `ABP` - ABP (American Board of Pediatrics)
 * * `ABPMR` - ABPMR (American Board of Physical Medicine and Rehabilitation)
 * * `ABPS` - ABPS (American Board of Physician Specialties)
 * * `ABPM` - ABPM (American Board of Preventive Medicine)
 * * `ABPN` - ABPN (American Board of Psychiatry and Neurology)
 * * `ABR` - ABR (American Board of Radiology)
 * * `ABS` - ABS (American Board of Surgery)
 * * `ABTS` - ABTS (American Board of Thoracic Surgery)
 * * `ABU` - ABU (American Board of Urology)
 * * `ABUCM` - ABUCM (American Board of Urgent Care Medicine)
 * * `AMCB` - AMCB (American Midwifery Certification Board)
 * * `AOBA` - AOBA (American Osteopathic Board of Anesthesiology)
 * * `AOBD` - AOBD (American Osteopathic Board of Dermatology)
 * * `AOBEM` - AOBEM (American Osteopathic Board of Emergency Medicine)
 * * `AOBFM` - AOBFM (American Osteopathic Board of Family Medicine)
 * * `AOBIM` - AOBIM (American Osteopathic Board of Internal Medicine)
 * * `AOBNMM` - AOBNMM (American Osteopathic Board of Neuromusculoskeletal Medicine)
 * * `AOBNM` - AOBNM (American Osteopathic Board of Nuclear Medicine)
 * * `AOBOG` - AOBOG (American Osteopathic Board of Obstetrics and Gynecology)
 * * `AOBO` - AOBO (American Osteopathic Board of Ophthalmology)
 * * `AOBOS` - AOBOS (American Osteopathic Board of Orthopedic Surgery)
 * * `AOBOTO` - AOBOTO (American Osteopathic Board of Otolaryngology)
 * * `AOBPA` - AOBPa (American Osteopathic Board of Pathology)
 * * `AOBP` - AOBP (American Osteopathic Board of Pediatrics)
 * * `AOBPMR` - AOBPMR (American Osteopathic Board of Physical Medicine and Rehabilitation)
 * * `AOBPM` - AOBPM (American Osteopathic Board of Preventative Medicine)
 * * `AOBPR` - AOBPR (American Osteopathic Board of Proctology)
 * * `AOBPN` - AOBPN (American Osteopathic Board of Psychiatry and Neurology)
 * * `AOBR` - AOBR (American Osteopathic Board of Radiology)
 * * `AOBS` - AOBS (American Osteopathic Board of Surgery)
 * * `AANP` - American Academy of Nurse Practitioners
 * * `ANCC` - American Nurses Credentialing Center
 * * `NBPAS` - NBPAS (National Board of Physicians and Surgeons)
 * * `NCCPA` - National Commission on Certification of Physician Assistants
 * * `NONE` - Not Boarded
 */
export enum BoardCertificationTypeEnum {
    ABAI = 'ABAI',
    ABA = 'ABA',
    ABD = 'ABD',
    ABEM = 'ABEM',
    ABFM = 'ABFM',
    ABIM = 'ABIM',
    ABMGG = 'ABMGG',
    ABNS = 'ABNS',
    ABOG = 'ABOG',
    ABO = 'ABO',
    ABOS = 'ABOS',
    ABOHNS = 'ABOHNS',
    ABPATH = 'ABPATH',
    ABP = 'ABP',
    ABPMR = 'ABPMR',
    ABPS = 'ABPS',
    ABPM = 'ABPM',
    ABPN = 'ABPN',
    ABR = 'ABR',
    ABS = 'ABS',
    ABTS = 'ABTS',
    ABU = 'ABU',
    ABUCM = 'ABUCM',
    AMCB = 'AMCB',
    AOBA = 'AOBA',
    AOBD = 'AOBD',
    AOBEM = 'AOBEM',
    AOBFM = 'AOBFM',
    AOBIM = 'AOBIM',
    AOBNMM = 'AOBNMM',
    AOBNM = 'AOBNM',
    AOBOG = 'AOBOG',
    AOBO = 'AOBO',
    AOBOS = 'AOBOS',
    AOBOTO = 'AOBOTO',
    AOBPA = 'AOBPA',
    AOBP = 'AOBP',
    AOBPMR = 'AOBPMR',
    AOBPM = 'AOBPM',
    AOBPR = 'AOBPR',
    AOBPN = 'AOBPN',
    AOBR = 'AOBR',
    AOBS = 'AOBS',
    AANP = 'AANP',
    ANCC = 'ANCC',
    NBPAS = 'NBPAS',
    NCCPA = 'NCCPA',
    NONE = 'NONE',
}
